import React from 'react';

import {TrackImpression} from '@udemy/event-tracking';

import styles from '../home-page.module.less';
import {BentoMessagingModule} from './bento-messaging-module.react-component';
import {TabsMessagingModule} from './tabs-messaging-module.react-component';

export interface MessagingModuleSlotProps {
    variant: 'control' | 'bento' | 'tabs' | undefined;
    onImpression: () => void;
}

/**
 * Renders the LIHP messaging module (CVR-2667) for whichever variant the experiment assigned,
 * and wires its own experiment-impression tracking. Pulled out of `home-page-feature.tsx` as
 * its own self-contained unit: deciding what renders here and firing its impression are one
 * concern, not something the rest of that file's render method needs to know the details of.
 */
export const MessagingModuleSlot = ({variant, onImpression}: MessagingModuleSlotProps) =>
    variant && variant !== 'control' ? (
        <TrackImpression trackFunc={onImpression} visibilityThreshold={0}>
            <div data-purpose="lihp-marketing-messaging-slot">
                {variant === 'bento' && <BentoMessagingModule />}
                {variant === 'tabs' && <TabsMessagingModule />}
            </div>
        </TrackImpression>
    ) : (
        <>
            {/* Control renders no content, so there's nothing for TrackImpression to
            measure — a dedicated 1px trigger gives it a real, non-zero-height target at
            the same scroll position bento/tabs' own content would start at, so control is
            bucketed on the same "user scrolled to this area" basis as the other arms. */}
            <TrackImpression trackFunc={onImpression} visibilityThreshold={0}>
                <div
                    aria-hidden="true"
                    data-purpose="lihp-marketing-messaging-impression-trigger"
                    className={styles['messaging-module-impression-trigger']}
                />
            </TrackImpression>
            <div
                data-purpose="lihp-marketing-messaging-slot"
                className="discovery-unit-empty-render"
            />
        </>
    );
